export default __webpack_public_path__ + "static/media/cases1.58f49fdf.jpg";